import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  Typography,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import { Refresh } from "@material-ui/icons";
import climaService from "@services/climaService";
import formatDate from "@utils/formatDate";

export default function ClimaUpdateStatus() {
  const [lastUpdated, setLastUpdated] = useState(null);
  const [loading, setLoading] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  const fetchLastUpdate = useCallback(async () => {
    console.log("oadjfsoidfa");
    setLoading(true);
    try {
      const result = await climaService.getClimaUpdateInfo();
      setLastUpdated(result?.modelrun_updatetime_utc);
    } catch (error) {
      console.error("Erro ao buscar última atualização:", error);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchLastUpdate();
  }, [fetchLastUpdate]);

  const handleConfirm = async () => {
    setDialogOpen(false);
    setUpdating(true);
    try {
      await climaService.runUpdate();
    } catch (error) {
      console.error("Erro ao atualizar clima:", error);
    }
    setUpdating(false);
  };

  const handleCancel = () => {
    setDialogOpen(false);
  };

  return (
    <div style={{ marginTop: 25 }}>
      <Typography>Clima</Typography>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box display="flex" alignItems="center">
          <Typography variant="subtitle2" style={{ marginRight: 4 }}>
            Última atualização:{" "}
          </Typography>

          <Typography variant="subtitle2">
            {loading ? (
              <CircularProgress size={16} />
            ) : lastUpdated ? (
              formatDate(lastUpdated + `Z`)
            ) : (
              "Não disponível"
            )}
          </Typography>
          <Tooltip title="Recarregar data">
            <IconButton
              size="small"
              onClick={fetchLastUpdate}
              disabled={loading}
              style={{ marginRight: 8, marginleft: 8 }}
            >
              <Refresh fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>

        <Button
          variant="contained"
          color="primary"
          onClick={() => setDialogOpen(true)}
          disabled={updating}
        >
          {updating ? "Atualizando..." : "Atualizar"}
        </Button>
      </Box>

      <Dialog open={dialogOpen} onClose={handleCancel}>
        <DialogTitle>Confirmar Atualização</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Tem certeza que deseja atualizar os dados climáticos agora? As
            atualizacoes demorarao cerca de 3 minutos para serem atualizadas
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel}>Não</Button>
          <Button onClick={handleConfirm} autoFocus>
            Sim
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
